import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./IconPicker.module.css";

import DRIcon from "shared/assets/ThumbnailColorIcons/DR_Icon.svg";
import DSIcon from "shared/assets/ThumbnailColorIcons/DS_Icon.svg";
import DNIcon from "shared/assets/ThumbnailColorIcons/DN_Icon.svg";
import ERIcon from "shared/assets/ThumbnailColorIcons/ER_Icon.svg";
import FRIcon from "shared/assets/ThumbnailColorIcons/FR_Icon.svg";
import FMAIcon from "shared/assets/ThumbnailColorIcons/FMA_Icon.svg";
import FEIcon from "shared/assets/ThumbnailColorIcons/FE_Selected_Icon.svg";
import SPIcon from "shared/assets/ThumbnailColorIcons/SP_Icon.svg";
import SLIcon from "shared/assets/ThumbnailColorIcons/SL_Icon.svg";
import ThreePIcon from "shared/assets/ThumbnailColorIcons/3P_Icon.svg";

const ICON_OPTIONS = [
  { key: "DR", src: DRIcon },
  { key: "DS", src: DSIcon },
  { key: "DN", src: DNIcon },
  { key: "ER", src: ERIcon },
  { key: "FR", src: FRIcon },
  { key: "FMA", src: FMAIcon },
  { key: "FE", src: FEIcon },
  { key: "SP", src: SPIcon },
  { key: "SL", src: SLIcon },
  { key: "3P", src: ThreePIcon },
];

export function IconPicker({
  selected,
  year,
  onChange,
  onYearChange,
  className,
}) {
  return (
    <section className={classNames(styles.card, className)}>
      <div className={styles.rowHeader}>
        <h3 className={styles.sectionTitle}>Icon</h3>
        <div className={styles.divider} />
      </div>

      <div className={styles.controlsColumn}>
        <div className={styles.iconGrid}>
          {ICON_OPTIONS.map((option) => {
            const isSelected = option.key === selected;

            return (
              <button
                key={option.key}
                type="button"
                className={classNames(styles.iconButton, {
                  [styles.iconButtonSelected]: isSelected,
                })}
                onClick={() => onChange(option.key)}
                aria-pressed={isSelected}
                aria-label={`Select ${option.key} icon`}
              >
                <img src={option.src} alt={`${option.key} icon`} />
              </button>
            );
          })}
        </div>

        <label htmlFor="icon-picker-year" className={styles.inputLabel}>
          Year
        </label>
        <input
          id="icon-picker-year"
          type="text"
          inputMode="numeric"
          className={styles.input}
          value={year}
          onChange={(event) =>
            onYearChange(event.target.value.replace(/\D/g, "").slice(0, 4))
          }
          placeholder="e.g. 2026"
          maxLength={4}
        />
      </div>
    </section>
  );
}

IconPicker.propTypes = {
  selected: PropTypes.oneOf(["", ...ICON_OPTIONS.map((option) => option.key)]),
  year: PropTypes.string,
  onChange: PropTypes.func,
  onYearChange: PropTypes.func,
  className: PropTypes.string,
};

IconPicker.defaultProps = {
  selected: "",
  year: "",
  onChange: () => {},
  onYearChange: () => {},
  className: undefined,
};

export default IconPicker;
